(function () {
  'use strict';

  const VERSION = '2.0.0';
  const ENDPOINT = 'https://izzlihdlujzqlnorqmtn.supabase.co/functions/v1/ranker-event';
  const STORE_KEY = 'patikasso_ranker_v2_events';
  const VISITOR_KEY = 'patikasso_ranker_visitor';
  const SESSION_KEY = 'patikasso_ranker_session';
  const seen = new Set();

  function uuid() {
    try { return crypto.randomUUID(); }
    catch (_) { return String(Date.now()) + '-' + Math.random().toString(36).slice(2); }
  }
  function getVisitorId() {
    try {
      let v = localStorage.getItem(VISITOR_KEY);
      if (!v) { v = uuid(); localStorage.setItem(VISITOR_KEY, v); }
      return v;
    } catch (_) { return null; }
  }
  function getSessionId() {
    try {
      let v = sessionStorage.getItem(SESSION_KEY);
      if (!v) { v = uuid(); sessionStorage.setItem(SESSION_KEY, v); }
      return v;
    } catch (_) { return null; }
  }
  function nowIso() { return new Date().toISOString(); }
  function productHandleFromUrl(url) {
    try {
      const u = new URL(url, location.origin);
      const m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    } catch (_) { return null; }
  }
  function collectionHandleFromPath() {
    const m = location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : (window.PatikassoContext && PatikassoContext.collectionHandle) || null;
  }
  function currentProductHandle() {
    return (window.PatikassoContext && PatikassoContext.productHandle) || productHandleFromUrl(location.href);
  }
  function currentProductId() {
    return (window.PatikassoContext && PatikassoContext.productId) || null;
  }
  function materialValue(value) {
    const v = String(value || '').trim();
    if (/kanvas/i.test(v)) return 'Kanvas';
    if (/\bmdf\b/i.test(v)) return 'MDF';
    if (/poster/i.test(v)) return 'Poster';
    return null;
  }
  function currentMaterial() {
    const nodes = document.querySelectorAll('input[type="radio"]:checked, select option:checked');
    for (const el of nodes) {
      const m = materialValue(el.value || el.textContent);
      if (m) return m;
    }
    return null;
  }
  function persist(evt) {
    try {
      const rows = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
      rows.push(evt);
      if (rows.length > 500) rows.splice(0, rows.length - 500);
      localStorage.setItem(STORE_KEY, JSON.stringify(rows));
    } catch (_) {}
  }
  function send(evt) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(evt)
      }).catch(() => {});
    } catch (_) {}
  }
  function emit(type, payload) {
    const evt = Object.assign({
      type,
      ts: nowIso(),
      version: VERSION,
      path: location.pathname,
      referrer: document.referrer || null,
      visitorId: getVisitorId(),
      sessionId: getSessionId(),
      collectionHandle: collectionHandleFromPath()
    }, payload || {});
    persist(evt);
    send(evt);
    window.dispatchEvent(new CustomEvent('patikasso:ranker', { detail: evt }));
  }

  function cardInfo(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const handle = productHandleFromUrl(link.href);
    if (!handle) return null;
    let productId = null;
    const candidates = Array.from(card.querySelectorAll('[id]'));
    for (const el of candidates) {
      const m = String(el.id).match(/(?:title-|quick-add-|QuickAdd-)(?:[^0-9]*)(\d{8,})/);
      if (m) { productId = m[1]; break; }
    }
    return { handle, productId };
  }

  function initCards() {
    const cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
    if (!cards.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        const card = entry.target;
        const info = cardInfo(card);
        if (!info) return;
        const key = 'imp:' + (info.productId || info.handle);
        if (seen.has(key)) return;
        setTimeout(() => {
          const r = card.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          const visiblePixels = Math.min(r.bottom, vh) - Math.max(r.top, 0);
          const ratio = r.height > 0 ? visiblePixels / r.height : 0;
          if (ratio >= 0.5 && !seen.has(key)) {
            seen.add(key);
            emit('impression', info);
          }
        }, 800);
      });
    }, { threshold: [0.5] });

    cards.forEach((card) => {
      if (card.dataset.patikassoRankerBound === '1') return;
      card.dataset.patikassoRankerBound = '1';
      observer.observe(card);
      card.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="/products/"]');
        if (!link) return;
        const info = cardInfo(card);
        if (info) emit('product_click', info);
      }, true);
    });
  }

  function initMaterialTracking(handle, productId) {
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!(el instanceof HTMLInputElement || el instanceof HTMLSelectElement)) return;

      let value = null;
      if (el instanceof HTMLSelectElement) {
        value = el.options[el.selectedIndex] ? el.options[el.selectedIndex].textContent : el.value;
      } else {
        value = el.value;
        if (!value && el.labels && el.labels[0]) value = el.labels[0].textContent;
      }

      const material = materialValue(value);
      if (!material) return;
      emit('material_select', { handle, productId, material });
    }, true);
  }

  function initProductPage() {
    const handle = currentProductHandle();
    if (!handle) return;
    const productId = currentProductId();

    const key = 'view:' + (productId || handle);
    if (!seen.has(key)) {
      seen.add(key);
      emit('product_view', { handle, productId });
    }

    initMaterialTracking(handle, productId);

    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      emit('add_to_cart', {
        handle,
        productId,
        variantId: variantInput ? variantInput.value : null,
        material: currentMaterial()
      });
    }, true);
  }

  function init() {
    initCards();
    initProductPage();

    const mo = new MutationObserver(() => initCards());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.PatikassoRanker = {
      version: VERSION,
      endpoint: ENDPOINT,
      events: function () {
        try { return JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); }
        catch (_) { return []; }
      },
      clear: function () { localStorage.removeItem(STORE_KEY); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();